import React from 'react'
import { Email, Item, Box } from 'react-html-email';
import { Provider, ReactReduxContext } from 'react-redux'

import { renderToString } from 'react-dom/server'

import Header from "./email/header";
import Footer from "./email/footer";
import Body from "./email/body";

const css = `
html, body {
  margin: 0;
  padding: 0;
  width: 100% !important;
}
img {
  max-width: 100%;
  height: auto;
}
table {
  max-width: 100%;
}
@media only screen and (max-width: 480px) {
  table[width="600"] {
    width: 100% !important;
  }
}`.trim()

const email = ({ html = false}) => (
  <ReactReduxContext.Consumer>
    {({ store }) => (
      (<Email title="Test Email" headCSS={css}>
        <Item>
          <Box width="100%" >
            <tr><td dangerouslySetInnerHTML={{
              __html: renderToString(
                <Provider store={store}>
                  <Header html={html}/>
                </Provider>
              )
            }}></td></tr>
          </Box>
        </Item>
        <Item>
          <Box width="100%" >
            <tr><td dangerouslySetInnerHTML={{
              __html: renderToString(
                <Provider store={store}>
                  <Body html={html}/>
                </Provider>
              )
            }}></td></tr>
          </Box>
        </Item>
        <Item>
          <Box width="100%" >
            <tr><td dangerouslySetInnerHTML={{
              __html: renderToString(
                <Provider store={store}>
                  <Footer html={html}/>
                </Provider>
              )
            }}></td></tr>
          </Box>
        </Item>
      </Email>)
    )}
  </ReactReduxContext.Consumer>
)

export default email
